import * as squint_core from 'squint-cljs/core.js';
import { openDB } from 'idb';
import { h, render } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as flow from './cljdoc.client.flow.jsx';
import * as cljdoc_DOT_client_DOT_flow from './cljdoc.client.flow.jsx';
import * as search_logic from './cljdoc.client.single-docset-search.logic.jsx';
import * as cljdoc_DOT_client_DOT_single_docset_search_DOT_logic from './cljdoc.client.single-docset-search.logic.jsx';
import * as str from 'squint-cljs/src/squint/string.js';
import * as clojure_DOT_string from 'squint-cljs/src/squint/string.js';
var SEARCHSET_VERSION = 7;
var clamp = function (value, min_value, max_value) {
return squint_core.min(squint_core.max(value, min_value), max_value);

};
var is_expired = function (date_string) {
const date_1 = (new Date(date_string));
const expires_at_2 = (new Date());
const now_3 = (new Date());
expires_at_2.setDate((date_1.getDate() + 1));
return (now_3 > expires_at_2);

};
var evict_bad_search_sets = async function (db) {
const keys_1 = (await db.getAllKeys("searchsets"));
for (let G__2 of squint_core.iterable(keys_1)) {
const key_3 = G__2;
const stored_searchset_4 = (await db.get("searchsets", key_3));
if (squint_core.truth_(((squint_core.truth_(stored_searchset_4)) ? (((!squint_core._EQ_(squint_core.get(stored_searchset_4, "version"), SEARCHSET_VERSION)) || ((await (async () => {
const or_5_6 = is_expired(squint_core.get(stored_searchset_4, "stored-at"));
if (squint_core.truth_(or_5_6)) {
return or_5_6} else {
return squint_core.not(squint_core.seq(stored_searchset_4))};

})())))) : (stored_searchset_4)))) {
(await db.delete("searchsets", key_3))}
};
return db;

};
var fetch_index_items = async function (url, db) {
const stored_searchset_1 = (await db.get("searchsets", url));
if (squint_core.truth_(((squint_core.truth_(stored_searchset_1)) ? (((squint_core._EQ_(squint_core.get(stored_searchset_1, "version"), SEARCHSET_VERSION)) && (((squint_core.not(is_expired(squint_core.get(stored_searchset_1, "stored-at")))) && (squint_core.seq(stored_searchset_1)))))) : (stored_searchset_1)))) {
return squint_core.get(stored_searchset_1, "indexItems")} else {
const response_2 = (await fetch(url));
const search_set_3 = (await response_2.json());
const items_4 = squint_core.vec(squint_core.map_indexed((function (ndx, item) {
return squint_core.assoc(item, "id", ndx);

}), squint_core.reduce(squint_core.into, [], [squint_core.mapv((function (_PERCENT_1_SHARP_) {
return squint_core.assoc(_PERCENT_1_SHARP_, "kind", "namespace");

}), squint_core.get(search_set_3, "namespaces")), squint_core.mapv((function (_PERCENT_1_SHARP_) {
return squint_core.assoc(_PERCENT_1_SHARP_, "kind", "def");

}), squint_core.get(search_set_3, "defs")), squint_core.mapv((function (_PERCENT_1_SHARP_) {
return squint_core.assoc(_PERCENT_1_SHARP_, "kind", "def");

}), squint_core.mapcat(squint_core.identity, squint_core.keep((function (_PERCENT_1_SHARP_) {
const temp__6897__auto___5 = squint_core.seq(squint_core.get(_PERCENT_1_SHARP_, "members"));
if (squint_core.truth_(temp__6897__auto___5)) {
const members_6 = temp__6897__auto___5;
return squint_core.mapv((function (m) {
return squint_core.assoc(m, "namespace", squint_core.get(_PERCENT_1_SHARP_, "namespace"), "protocol-name", squint_core.get(_PERCENT_1_SHARP_, "name"));

}), members_6);
};

}), squint_core.get(search_set_3, "defs")))), squint_core.mapv((function (_PERCENT_1_SHARP_) {
return squint_core.assoc(_PERCENT_1_SHARP_, "kind", "doc");

}), squint_core.get(search_set_3, "docs"))])));
(await db.put("searchsets", ({"storedAt": (new Date()).toISOString(), "version": SEARCHSET_VERSION, "indexItems": items_4}), url));
return items_4;
};

};
var ResultIcon = function (p__11349) {
const map___1_3 = p__11349;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const item_5 = squint_core.get(map___1_4, "item");
const colors_8 = ({"NS": "bg-light-purple", "DOC": "bg-green", "VAR": "bg-dark-blue", "MAC": "bg-dark-red", "PRO": "bg-light-red"});
const default_color_9 = "bg-black-70";
const map___6_10 = (() => {
const G__11350_11 = squint_core.get(item_5, "kind");
switch (G__11350_11) {case "namespace":
return ({"text": "NS"});

break;
case "def":
return ({"label": squint_core.get(item_5, "type"), "text": str.upper_case(squint_core.subs(squint_core.get(item_5, "type"), 0, 3))});

break;
case "doc":
return ({"text": "DOC"});

break;
default:
throw (new Error(`${"No matching clause: "}${G__11350_11??''}`))};

})();
const map___6_13 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___6_10))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___6_10))) ? (map___6_10) : (squint_core.seq_to_map_for_destructuring(map___6_10)))) : (map___6_10));
const text_14 = squint_core.get(map___6_13, "text");
const label_15 = squint_core.get(map___6_13, "label");
const color_16 = (text_14 in colors_8 ? colors_8[text_14] : default_color_9);
return <><div class={`${"dib pa1 white-90 br1 mr2 tc f6 "}${color_16??''}`} style="width:2.5rem; font-size: 13px; margin-bottom: 2px;" aria-label={label_15} title={label_15}>{text_14}</div></>;

};
var ResultName = function (p__11351) {
const map___1_3 = p__11351;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const item_5 = squint_core.get(map___1_4, "item");
if (("def" === squint_core.get(item_5, "kind"))) {
return <><div class="mb1"><span>{squint_core.get(item_5, "namespace")}</span>/{squint_core.get(item_5, "name")}</div></>} else {
return <><div class="mb1">{squint_core.get(item_5, "name")}</div></>};

};
var ResultProtocol = function (p__11352) {
const map___1_3 = p__11352;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const item_5 = squint_core.get(map___1_4, "item");
if (squint_core.truth_(squint_core.get(item_5, "protocol-name"))) {
return <><div class="ml2 nowrap">{h(ResultIcon, ({"item": ({"kind": "def", "type": "protocol"})}))}<span>{squint_core.get(item_5, "protocol-name")}</span></div></>;
};

};
var ResultListItem = function (p__11353) {
const map___1_3 = p__11353;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const searchResult_5 = squint_core.get(map___1_4, "searchResult");
const selected_6 = squint_core.get(map___1_4, "selected");
const onClick_7 = squint_core.get(map___1_4, "onClick");
const onMouseDown_8 = squint_core.get(map___1_4, "onMouseDown");
const item_9 = useRef(null);
useEffect((function () {
if (squint_core.truth_((() => {
const and_10_11 = item_9.current;
if (squint_core.truth_(and_10_11)) {
return selected_6} else {
return and_10_11};

})())) {
return item_9.current.scrollIntoView(({"block": "nearest"}));
};

}), [item_9.current, selected_6]);
const result_12 = squint_core.get(searchResult_5, "doc");
return <><li class={(() => {
const G__11354_13 = "pa2 bb b--light-gray";
if (squint_core.truth_(selected_6)) {
return `${G__11354_13}${" bg-light-blue"}`} else {
return G__11354_13};

})()} ref={item_9}><a class="no-underline black" href={squint_core.get(result_12, "path")} onMouseDown={(function (e) {
if (squint_core.truth_(onMouseDown_8)) {
return onMouseDown_8(e);
};

})} onclick={(function (e) {
if (squint_core.truth_(onClick_7)) {
return onClick_7(e);
};

})}><div class="flex flex-row items-end">{h(ResultIcon, ({"item": result_12}))}<div class="flex flex-column">{h(ResultName, ({"item": result_12}))}</div><div class="flex">{h(ResultProtocol, ({"item": result_12}))}</div></div></a></li></>;

};
var SingleDocsetSearch = function (p__11355) {
const map___1_3 = p__11355;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const url_5 = squint_core.get(map___1_4, "url");
const vec___6_27 = useState(null);
const db_28 = squint_core.nth(vec___6_27, 0, null);
const set_db_BANG__29 = squint_core.nth(vec___6_27, 1, null);
const vec___9_30 = useState(null);
const index_items_31 = squint_core.nth(vec___9_30, 0, null);
const set_index_items_BANG__32 = squint_core.nth(vec___9_30, 1, null);
const vec___12_33 = useState(null);
const search_index_34 = squint_core.nth(vec___12_33, 0, null);
const set_search_index_BANG__35 = squint_core.nth(vec___12_33, 1, null);
const vec___15_36 = useState([]);
const results_37 = squint_core.nth(vec___15_36, 0, null);
const set_results_BANG__38 = squint_core.nth(vec___15_36, 1, null);
const vec___18_39 = useState(false);
const show_results_40 = squint_core.nth(vec___18_39, 0, null);
const set_show_results_BANG__41 = squint_core.nth(vec___18_39, 1, null);
const vec___21_42 = useState(null);
const selected_ndx_43 = squint_core.nth(vec___21_42, 0, null);
const set_selected_ndx_BANG__44 = squint_core.nth(vec___21_42, 1, null);
const current_url_45 = (new URL(window.location.href));
const vec___24_46 = useState((() => {
const or_47_48 = current_url_45.searchParams.get("q");
if (squint_core.truth_(or_47_48)) {
return or_47_48} else {
return ""};

})());
const input_value_49 = squint_core.nth(vec___24_46, 0, null);
const set_input_value_BANG__50 = squint_core.nth(vec___24_46, 1, null);
const input_elem_51 = useRef(null);
useEffect((function init_input_elem () {
const on_global_key_down_52 = (function (p__11356) {
const map___53_55 = p__11356;
const map___53_56 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___53_55))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___53_55))) ? (map___53_55) : (squint_core.seq_to_map_for_destructuring(map___53_55)))) : (map___53_55));
const e_57 = map___53_56;
const key_58 = squint_core.get(map___53_56, "key");
if (squint_core.truth_((() => {
const and_59_60 = input_elem_51.current;
if (squint_core.truth_(and_59_60)) {
const and_63_64 = (() => {
const or_61_62 = e_57.metaKey;
if (squint_core.truth_(or_61_62)) {
return or_61_62} else {
return e_57.ctrlKey};

})();
if (squint_core.truth_(and_63_64)) {
return ("/" === key_58)} else {
return and_63_64};
} else {
return and_59_60};

})())) {
return input_elem_51.current.focus();
};

});
document.addEventListener("keydown", on_global_key_down_52);
return function () {
return document.removeEventListener("keydown", on_global_key_down_52);

};

}), [input_elem_51]);
useEffect((function init_db () {
const db_version_65 = 1;
return openDB("cljdoc-searchsets-store", db_version_65, ({"upgrade": (function (db) {
return db.createObjectStore("searchsets");

})})).then(evict_bad_search_sets).then(set_db_BANG__29).catch(console.error);

}), []);
useEffect((function fetch_index () {
if (squint_core.truth_(db_28)) {
return fetch_index_items(url_5, db_28).then(set_index_items_BANG__32).catch(console.error);
};

}), [url_5, db_28]);
useEffect((function build_index () {
if (squint_core.truth_(index_items_31)) {
return set_search_index_BANG__35(search_logic.build_search_index(index_items_31));
};

}), [index_items_31]);
const on_arrow_up_66 = (function () {
if (squint_core.truth_(squint_core.seq(results_37))) {
const max_67 = (squint_core.count(results_37) - 1);
if (((squint_core.not(selected_ndx_43)) || ((selected_ndx_43 === 0)))) {
return set_selected_ndx_BANG__44(max_67)} else {
return set_selected_ndx_BANG__44((selected_ndx_43 - 1))};
} else {
return set_selected_ndx_BANG__44(null)};

});
const on_arrow_down_68 = (function () {
if (squint_core.truth_(squint_core.seq(results_37))) {
const max_69 = (squint_core.count(results_37) - 1);
if (((squint_core.not(selected_ndx_43)) || ((selected_ndx_43 === max_69)))) {
return set_selected_ndx_BANG__44(0)} else {
return set_selected_ndx_BANG__44((selected_ndx_43 + 1))};
} else {
return set_selected_ndx_BANG__44(null)};

});
const clamp_selected_ndx_70 = (function () {
if (squint_core.truth_(selected_ndx_43)) {
if (squint_core.not(squint_core.seq(results_37))) {
return set_selected_ndx_BANG__44(null)} else {
const ndx_71 = clamp(selected_ndx_43, 0, (squint_core.count(results_37) - 1));
if (!squint_core._EQ_(ndx_71, selected_ndx_43)) {
return set_selected_ndx_BANG__44(ndx_71);
};
};
};

});
const on_result_navigation_72 = (function (path) {
const temp__6897__auto___73 = input_elem_51.current;
if (squint_core.truth_(temp__6897__auto___73)) {
const input_74 = temp__6897__auto___73;
const redirect_to_75 = (new URL(`${window.location.origin??''}${path??''}`));
const params_76 = redirect_to_75.searchParams;
params_76.set("q", input_74.value);
redirect_to_75.search = params_76.toString();
if (!squint_core._EQ_(current_url_45.href, redirect_to_75.href)) {
window.location.assign(redirect_to_75.toString())};
if (squint_core.truth_(show_results_40)) {
set_show_results_BANG__41(false);
return input_74.blur();
};
};

});
const handle_search_77 = flow.debounced(300, (function (query) {
const results_78 = search_logic.search(search_index_34, query);
if (squint_core.truth_(results_78)) {
set_results_BANG__38(results_78)} else {
set_results_BANG__38([])};
if (squint_core.truth_(show_results_40)) {
return null} else {
return set_show_results_BANG__41(true);
};

}));
clamp_selected_ndx_70();
return <><div><form class="black-80 w-100" onSubmit={(function (e) {
return e.preventDefault();

})}><div style="position: relative"><svg class="w1 h1" style="position: absolute; left: 0.58rem; top: 0.58rem; z-index: 1; stroke: currentColor; stroke-width: 3; fill: none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="11.963" cy="8.7873" r="7.2449"></circle><line x1="16.075" y1="15.902" x2="20.357" y2="23.212"></line></svg><input placeholder={((squint_core.truth_(search_index_34)) ? ("Search...") : ("Loading..."))} disabled={squint_core.not(search_index_34)} ref={input_elem_51} name="single-docset-search-term" value={input_value_49} type="text" onBlur={(function (p__11357) {
const map___79_81 = p__11357;
const map___79_82 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___79_81))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___79_81))) ? (map___79_81) : (squint_core.seq_to_map_for_destructuring(map___79_81)))) : (map___79_81));
const _e_83 = map___79_82;
const target_84 = squint_core.get(map___79_82, "target");
dom.toggle_class(target_84, "b--blue");
if (squint_core.truth_(show_results_40)) {
return set_show_results_BANG__41(false);
};

})} class="input-reset ba b--black-20 pa2 pl4 db br1 w-100" aria-describedby="single-docset-search-term-description" onInput={(function (p__11358) {
const map___85_87 = p__11358;
const map___85_88 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___85_87))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___85_87))) ? (map___85_87) : (squint_core.seq_to_map_for_destructuring(map___85_87)))) : (map___85_87));
const e_89 = map___85_88;
const target_90 = squint_core.get(map___85_88, "target");
e_89.preventDefault();
const value_91 = target_90.value;
set_input_value_BANG__50(value_91);
return handle_search_77(value_91);

})} onKeyDown={(function (p__11359) {
const map___92_94 = p__11359;
const map___92_95 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___92_94))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___92_94))) ? (map___92_94) : (squint_core.seq_to_map_for_destructuring(map___92_94)))) : (map___92_94));
const e_96 = map___92_95;
const target_97 = squint_core.get(map___92_95, "target");
const key_98 = squint_core.get(map___92_95, "key");
const G__11360_99 = key_98;
switch (G__11360_99) {case "Escape":
if (squint_core.truth_(show_results_40)) {
return set_show_results_BANG__41(false)} else {
return target_97.blur()};

break;
case "ArrowUp":
e_96.preventDefault();
if (squint_core.truth_(show_results_40)) {
} else {
set_show_results_BANG__41(true)};
return on_arrow_up_66();

break;
case "ArrowDown":
e_96.preventDefault();
if (squint_core.truth_(show_results_40)) {
} else {
set_show_results_BANG__41(true)};
return on_arrow_down_68();

break;
case "Enter":
e_96.preventDefault();
if (squint_core.truth_(show_results_40)) {
if (squint_core.truth_(((squint_core.truth_(selected_ndx_43)) ? (squint_core.seq(results_37)) : (selected_ndx_43)))) {
return on_result_navigation_72(squint_core.get(squint_core.get(squint_core.get(results_37, selected_ndx_43), "doc"), "path"));
}} else {
return set_show_results_BANG__41(true)};

break;
};

})} onFocus={(function (p__11361) {
const map___101_103 = p__11361;
const map___101_104 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___101_103))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___101_103))) ? (map___101_103) : (squint_core.seq_to_map_for_destructuring(map___101_103)))) : (map___101_103));
const _e_105 = map___101_104;
const target_106 = squint_core.get(map___101_104, "target");
return handle_search_77(target_106.value);

})}></input></div>{((squint_core.truth_(((squint_core.truth_(show_results_40)) ? (squint_core.seq(results_37)) : (show_results_40)))) ? (<><ol class="list pa0 ma0 no-underline black bg-white br--bottom ba br1 b--blue absolute overflow-y-scroll" style="z-index:1; max-width: 90vw; max-height: 80vh">{squint_core.vec(squint_core.lazy((function* () {
for (let G__107 of squint_core.iterable(squint_core.map_indexed(squint_core.vector, results_37))) {
const vec___108_111 = G__107;
const ndx_112 = squint_core.nth(vec___108_111, 0, null);
const result_113 = squint_core.nth(vec___108_111, 1, null);
yield h(ResultListItem, ({"searchResult": result_113, "index": ndx_112, "selected": squint_core._EQ_(selected_ndx_43, ndx_112), "onMouseDown": (function (e) {
return e.preventDefault();

}), "onClick": (function (e) {
e.preventDefault();
return on_result_navigation_72(squint_core.get(squint_core.get(result_113, "doc"), "path"));

})}));
}
return null;

})))}</ol></>) : (null))}</form></div></>;

};
var init = async function () {
const single_docset_search_node_1 = dom.query("[data-id='cljdoc-js--single-docset-search']");
const url_2 = (await (async () => {
const G__11362_3 = single_docset_search_node_1;
const G__11362_4 = (((G__11362_3 == null)) ? (null) : (G__11362_3.dataset));
if ((G__11362_4 == null)) {
return null} else {
return G__11362_4.searchsetUrl};

})());
if (squint_core.truth_(((squint_core.truth_(single_docset_search_node_1)) ? (squint_core.string_QMARK_(url_2)) : (single_docset_search_node_1)))) {
return render(h(SingleDocsetSearch, ({"url": url_2})), single_docset_search_node_1);
};

};

export { SEARCHSET_VERSION, init }
